import React from 'react';
import s from './Stores.module.scss';
import { useNavigate } from 'react-router-dom';
import useGetAllStores from 'sdk/hooks/shop/useGetAllStores';
import StoreCard from './StoreCard';
import { useTranslation } from 'react-i18next';
import ForwardArrow from 'modules/app/components/UI/ForwardArrow';

const Stores = () => {
    const { data: stores } = useGetAllStores(9);
    const navigate = useNavigate();
    const { t } = useTranslation() as any;

    const servicesTitle = (text: string) => (
        <div className={s.services_title}>
            <div className={s.services_title_title}>{text}</div>
            <div className={s.services_title_see}>
                <div onClick={() => navigate('/all-stores')}>{t('See All')}</div>
                <ForwardArrow />
            </div>
        </div>
    );

    return (
        <div className={s.container}>
            {servicesTitle(t('Stores'))}
            <div className={s.products}>
                <div className={s.grid}>
                    {stores?.map((item) => (
                        <StoreCard
                            key={item.id}
                            id={item.id}
                            avatar={item.avatar}
                            store_name={item.store_name}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Stores;